import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AutenticacaoProvedora } from './contextos/AutenticacaoContexto';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AutenticacaoProvedora>
      <App />
    </AutenticacaoProvedora>
  </React.StrictMode>
);
